import { createFileRoute } from "@tanstack/react-router";
import SavedInsights from "@/components/views/SavedInsights";

export const Route = createFileRoute("/insights")({
  component: SavedInsights,
});
